@if (patient()) {
  <div class="top-navi-container no-print">
    <button class="top-navi" routerLink="/patients" mat-button><mat-icon>arrow_back</mat-icon>Alle Patienten</button>
    <div class="top-navi align-right flex">
      <button (click)="print()" mat-button><mat-icon>print</mat-icon>Drucken</button>
      <button routerLink="../assessments" mat-button><mat-icon>list</mat-icon>Befunde</button>
    </div>
  </div>
  <mat-card class="card no-print" id="print-root">
    <mat-card-content class="do-print">
      <h1>Bericht</h1>
      <h3>{{ patient()?.uid }} ({{ patient() | ageString }})</h3>
      <h5>
        betroffen:
        {{ patient()?.affectedSide | sideString }}, dominant:
        {{ patient()?.dominantSide | sideString }}
      </h5>
      <div class="top-buttons">
        <!-- <button mat-raised-button (click)="newAssessment()">Neue Testung</button> -->
      </div>
    </mat-card-content>

    <div class="table">
      <div class="report-row table-header do-print">
        <div class="top">
          <div class="left">
            <div class="title">ICF-Kategorie</div>
            <div class="score">ICF Score</div>
          </div>
          <div class="right">Notizen</div>
        </div>
      </div>
      @for (item of reportList() ?? []; track $index) {
        <app-report-row [item]="item" class="do-print"></app-report-row>
      }
    </div>
  </mat-card>
} @else {
  <br />
  <br />
  Lade Patientendaten...
}
